import React, { useState, useEffect } from 'react';
import { MessageBox, Select, message } from 'kenshin';

const CopyTaskModal = ({
  visible,
  onCancel,
  onOk,
  tabs = [],
  currentTask,
  title = '复制任务',
}) => {
  const [targetSheetId, setTargetSheetId] = useState(undefined);

  useEffect(() => {
    if (visible) {
      setTargetSheetId(undefined); // Reset when opening
    }
  }, [visible]);

  const handleOk = () => {
    if (!targetSheetId) {
      message.error('请选择目标表格');
      return;
    }
    onOk(targetSheetId);
  };

  const sheetOptions = tabs.map((tab) => ({
    label: tab.name,
    value: tab.id,
  }));

  return (
    <MessageBox
      title={title}
      visible={visible}
      onCancel={onCancel}
      onOk={handleOk}
      destroyOnClose
    >
      <div style={{ marginBottom: 16 }}>
        <span style={{ marginRight: 8 }}>当前任务:</span>
        <strong>{currentTask?.taskName || '未命名任务'}</strong>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ marginRight: 8, whiteSpace: 'nowrap' }}>目标表格:</span>
        <Select
          style={{ width: '100%' }}
          placeholder="请选择目标表格"
          options={sheetOptions}
          value={targetSheetId}
          onChange={setTargetSheetId}
        />
      </div>
    </MessageBox>
  );
};

export default CopyTaskModal;
